import { render, staticRenderFns } from "./OnboardModal.vue?vue&type=template&id=91bd5650&"
import script from "./OnboardModal.vue?vue&type=script&lang=js&"
export * from "./OnboardModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports